import React from "react";
import "./MicroBladingContent.css";
import microBladingContent from "./../../../../Images/ServicePage/Eyebrow Microblading in Bangalore.png";
const MicroBladingContent = () => {
  return (
    <div className="microBladingContent">
      <div className="microBladingItem">
        <img src={microBladingContent} alt="microBladingContent" />
      </div>
      <div className="microBladingItem" id="microBladingItemTxt">
        <h2> Eyebrow Microblading in Bangalore</h2>
        <p>
          Achieve perfectly defined and natural-looking brows effortlessly with
          Eyebrow Microblading. This semi-permanent cosmetic treatment employs a
          specialized handheld tool to craft fine, hair-like strokes on your
          skin, enhancing and shaping your eyebrows with precision. Our expert
          technicians are dedicated to meticulously enhancing your brows,
          ensuring results that are both long-lasting and beautifully shaped.
          Tailored to your unique style, each treatment is designed to
          complement your natural beauty, giving you the perfect brows you’ve
          always desired. Say goodbye to daily brow maintenance and hello to
          flawless, natural-looking eyebrows with our professional microblading
          services. Whether you desire subtle definition or a bold, striking
          look, our skilled technicians will create a customized brow shape that
          enhances your facial features and fits your personal aesthetic.
          Experience the confidence that comes with expertly shaped brows and
          enjoy the convenience of a low-maintenance beauty routine with our
          premier eyebrow microblading service.
        </p>
        <button>
          <a href="https://scent.zenoti.com/webstoreNew/services">Book Now</a>
        </button>
      </div>
    </div>
  );
};

export default MicroBladingContent;
